module.exports = __webpack_public_path__ + "static/media/design1.91337ab5.png";